module.exports = __webpack_public_path__ + "img/BEST_PRACTICE.3a4a0105.svg";